<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>拼团活动详情</b>
    </a-divider>
    <a-descriptions :column="2" bordered>
      <a-descriptions-item label="活动名称">
        {{ form.acName }}
      </a-descriptions-item>
      <a-descriptions-item label="成团人数">
        {{ form.groupNumber }}人
      </a-descriptions-item>
      <a-descriptions-item label="拼团有效期">
        {{ form.groupValidTime }}小时
      </a-descriptions-item>
      <a-descriptions-item label="最大购买数量">
        {{ form.maxBuyBount }}件
      </a-descriptions-item>
      <a-descriptions-item label="拼团开始时间">
        {{ parseTime(form.acStartTime) }}
      </a-descriptions-item>
      <a-descriptions-item label="拼团结束时间">
        {{ parseTime(form.acEndTime) }}
      </a-descriptions-item>
      <a-descriptions-item label="审核状态">
        <span v-if="form.checkStatus == '1'">待审核</span>
        <span v-if="form.checkStatus == '2'">审核失败</span>
        <span v-if="form.checkStatus == '3'">审核成功</span>
        <span v-if="form.checkStatus == '4'">过期未审核</span>
        <span v-if="form.checkStatus == '5'">活动已结束</span>
      </a-descriptions-item>
      <a-descriptions-item label="虚拟成团">
        <span v-if="form.virtualGroupEnable == 1" style="color: #52c41a;">已开启</span>
        <span v-else style="color: #999;">未开启</span>
      </a-descriptions-item>
      <a-descriptions-item label="拒绝原因" v-if="form.checkStatus == '2'">
        {{ form.auditMessage || '-' }}
      </a-descriptions-item>
    </a-descriptions>

    <a-divider orientation="left">
      <b>商品信息</b>
    </a-divider>
    <a-descriptions :column="2" bordered>
      <a-descriptions-item label="商品名称">
        {{ form.goodsName }}
      </a-descriptions-item>
      <a-descriptions-item label="商品主图">
        <img v-if="form.goodsPicture" :src="form.goodsPicture" style="width:60px;height:60px;" @click="handleRecordPreview(form.goodsPicture)" alt=""/>
        <span v-else>-</span>
      </a-descriptions-item>
    </a-descriptions>

    <a-divider orientation="left">
      <b>SKU拼团价格11</b>
    </a-divider>
    <a-table
      :loading="skuLoading"
      rowKey="id"
      :size="tableSize"
      :columns="skuColumns"
      :data-source="skuList"
      :pagination="false"
      :bordered="true"
      style="width: 80%"
    >
      <template slot="skuPicture" slot-scope="text, record">
        <div>
          <img v-if="record.picture" :src="record.picture" style="width:40px;height:40px;" @click="handleRecordPreview(record.picture)" alt=""/>
        </div>
      </template>
      <template slot="groupPrice" slot-scope="text, record">
        <span style="color: #ff4d4f; font-weight: bold;">¥{{ record.groupPrice }}</span>
      </template>
    </a-table>

    <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
      <img alt="example" style="width: 100%" :src="previewUrl" />
    </a-modal>
  </a-drawer>
</template>

<script>
  import { getGroupActivityProd } from '@/api/groupActivityProd/groupActivityProd'
  import {mapGetters} from 'vuex'
  import { querySkuByGoodsId, getGoods } from '@/api/goods/goods'

  export default {
    name: 'DetailForm',
    data () {
      return {
        loading: false,
        skuLoading: false,
        open: false,
        previewImageVisible: false,
        previewUrl: '',
        form: {
          id: null,
          shopId: null,
          goodsId: null,
          acName: null,
          groupValidTime: null,
          groupNumber: null,
          goodsName: null,
          acPrice: null,
          goodsPrice: null,
          goodsPicture: null,
          checkStatus: '0',
          auditMessage: null,
          acStartTime: null,
          acEndTime: null,
          maxBuyBount: null,
          completeTotal: null,
          createTime: null,
          remark: null,
        },
        skuList: [],
        skuColumns: [
          {
            title: 'SKU名称',
            dataIndex: 'skuName',
            width: 100,
          },
          {
            title: 'SKU图片',
            dataIndex: 'picture',
            width: 60,
            scopedSlots: {customRender: 'skuPicture'},
          },
          {
            title: '原价',
            dataIndex: 'price',
            width: 70,
          },
          {
            title: '拼团价格',
            dataIndex: 'groupPrice',
            width: 100,
            scopedSlots: {customRender: 'groupPrice'},
          },
        ],
      }
    },
    computed: {
      ...mapGetters(['tableSize'])
    },
    methods: {
      onClose () {
        this.open = false
        this.reset()
      },
      reset () {
        this.form = {
          id: null,
          shopId: null,
          goodsId: null,
          acName: null,
          groupValidTime: null,
          groupNumber: null,
          goodsName: null,
          acPrice: null,
          goodsPrice: null,
          goodsPicture: null,
          checkStatus: '0',
          auditMessage: null,
          acStartTime: null,
          acEndTime: null,
          maxBuyBount: null,
          completeTotal: null,
          createTime: null,
          remark: null,
        }
        this.skuList = []
      },
      handleDetail (row) {
        this.reset()
        const id = row.id
        getGroupActivityProd({"id":id}).then(response => {
          this.form = response.data
          // 加载SKU列表
          if (response.data.goodsId) {
            this.loadSkuList(response.data.goodsId)
          }
          this.open = true
        })
      },
      // 加载SKU列表
      loadSkuList(goodsId) {
        console.log('开始加载SKU列表, goodsId:', goodsId)
        this.skuLoading = true

        // 先加载商品详情以获取规格信息
        Promise.all([
          querySkuByGoodsId(goodsId),
          getGoods({ id: goodsId })
        ]).then(([skuResponse, goodsResponse]) => {
          console.log('获取SKU列表成功:', skuResponse.data)
          console.log('获取商品详情成功:', goodsResponse.data)

          const skuList = skuResponse.data || []
          const goodsDetail = goodsResponse.data || {}
          const specList = goodsDetail.specList || []

          // 创建规格值ID到规格名称的映射
          const specValueMap = {}
          specList.forEach(spec => {
            if (spec.specValueList) {
              spec.specValueList.forEach(specValue => {
                specValueMap[specValue.id] = {
                  specName: spec.specName,
                  specValueName: specValue.specValueName
                }
              })
            }
          })
          console.log('规格值映射:', specValueMap)

          this.skuList = skuList.map(sku => {
            // 解析specValueIds (格式可能是 "id1:id2:id3")
            let skuName = sku.skuName || ''
            if (sku.specValueIds) {
              const specValueIdArray = sku.specValueIds.split(':')
              const specNameArray = []
              specValueIdArray.forEach(id => {
                const specInfo = specValueMap[id]
                if (specInfo) {
                  specNameArray.push(`${specInfo.specName}:${specInfo.specValueName}`)
                }
              })
              if (specNameArray.length > 0) {
                skuName = specNameArray.join(' ')
              }
            }

            return {
              id: sku.id,
              skuId: sku.id,
              skuName: skuName,
              picture: sku.picture || '',
              price: sku.price || 0,
              groupPrice: sku.groupPrice || 0
            }
          })
          console.log('SKU处理后数据:', this.skuList)
          this.skuLoading = false
        }).catch(error => {
          console.error('加载SKU列表失败:', error)
          this.skuLoading = false
        })
      },
      previewImageCancel() {
        this.previewImageVisible = false;
      },
      handleRecordPreview(url) {
        this.previewUrl = url
        this.previewImageVisible = true
      },
    }
  }
</script>
